import { useState } from "react";

export const useNewInput = () => {
    const [isNewInputDialogOpen, setIsNewInputDialogOpen] = useState<boolean>(false);

    const toggleNewInputDialog = () => setIsNewInputDialogOpen(!isNewInputDialogOpen);

    return {
        isNewInputDialogOpen,
        toggleNewInputDialog,
    }
}